import React from 'react';

export default function ProgressCircle({ percentage }) {
  const strokeColor = `hsl(${percentage * 1.2}, 100%, 50%)`; 
  
  return (
    <div className="flex flex-col bg-white shadow-lg p-6 rounded-xl w-full h-full">
      {/* Title */}
      <div className="mb-6 font-bold text-gray-700 text-xl text-center">% of Rent Paid</div>
      
      {/* SVG Circle Container */}
      <div className="flex flex-1 justify-center items-center">
        <div className="relative w-40 h-60"> {/* Increased size from w-36/h-36 to w-40/h-40 */}
          <svg viewBox="0 0 36 36" className="top-0 left-0 absolute w-full h-full rotate-90 transform">
            <circle
              cx="18"
              cy="18"
              r="15.9155" 
              fill="white" 
              stroke="#e5e7eb" 
              strokeWidth="4"
            />
            
            
            {/* Progress Indicator */}
            <path
              className="transition-all duration-700 ease-in-out" // Smoother animation
              strokeWidth="4"
              stroke={strokeColor}
              strokeLinecap="round"
              fill="none"
              strokeDasharray={`${percentage}, 100`}
              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
            />
          </svg>
          
          {/* Percentage Text */}
          <div className="absolute inset-0 flex justify-center items-center">
            <span className="font-bold text-gray-800 text-2xl">{percentage}%</span>
          </div>
        </div>
      </div>
    </div>
  );
}